function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M94.4121+94.4274L22.7133+22.1972L21.2984+70.1654L30.6198+79.7781L29.1633+117.064L39.3587+156.389L30.6521+160.605L18.8645+181.361L11.5858+227.355L16.3808+258.534L26.3866+278.334L24.0405+296.889L30.4389+329.947L58.5715+340.186L43.0222+355.754L54.9658+385.612L108.498+379.854L117.883+372.816L166.083+387.105L199.356+373.72L199.614+364.041L250.795+388.514L283.981+369.678L278.708+357.96L324.693+365.934L332.675+349.735L331.437+331.987L352.062+317.581L365.514+298.42L378.676+218.306L372.522+203.278L366.373+188.263L380.107+167.09L365.228+109.865L346.058+96.4177L364.019+65.6704L364.019+51.8932L372.892+27.6363L304.446+94.6649L288.845+148.128L288.174+230.315L283.076+237.731L293.272+292.417L250.068+299.01L240.671+283.612L199.092+286.264L199.424+294.735L153.079+295.198L155.171+288.431L151.27+285.392L111.137+287.783L95.7828+303.218L101.405+244.682L101.19+168.869L98.3422+161.435L94.4121+94.4274Z",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M68.984+330.77L91.9713+306.848",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M142.732+314.51L119.224+363.028",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M199.325+297.255L199.838+316.978L203.194+316.634L199.811+322.489L199.013+352.409",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M297.907+297.979L322.509+324.253",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M275.01+351.55L256.818+316.771L252.318+314.176L222.613+314.777",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M331.294+176.477L329.49+184.695",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M314.121+234.304L315.324+240.718",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M82.7507+236.255L80.3539+246.84",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

function SvgForwardB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardB);
export default __webpack_public_path__ + "static/media/forward-b.c2f2bee2.svg";
export { ForwardRef as ReactComponent };